import React, { useState, useEffect } from "react";
import { Container, Row, Col, Accordion, FormGroup } from "react-bootstrap";
import Collection from "Pages/Collection/Collection";
import { useSelector, useDispatch } from "react-redux";
import CardNft from "Pages/CardNft/CardNft";
import { BrowserRouter, Link, NavLink, Outlet, Route, Router, Routes, useLocation, useNavigate } from "react-router-dom";
import TimeCountDown from "Component/TimeCoundDown/TimeCountDown";
import moment from "moment";

import  { Redirect } from 'react-router-dom'
import $ from 'jquery'
import {
  getItems,
  getCurrentUser,
  getFavourite,
  getActivities,
  getUserByWallet,
} from "store/actions";
import { Switch } from "@headlessui/react";
import ProfileHome from "./Home";
import ProfileNft from "./nft";
import { Input } from "reactstrap";

const Profiletabbing = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  const queryParams = new URLSearchParams(location?.search);
  const slug = queryParams.get("id");
  const history = useLocation();
  const { authToken, user, settings } = useSelector((state) => state?.Login);

  const { favourite } = useSelector((state) => state?.items);
  const data = useSelector((state) => state);
  const { items } = useSelector((state) => state?.items);
  const activities = useSelector((state) => state?.items);
  const showMoreItem = useSelector((state) => state?.items);
  let profile = useSelector((state) => state);

  const [toggleData, settoggleData] = useState([]);
  const [moreActivity, setmoreActivity] = useState([]);
  const [state, setState] = useState({ tab: "tab1" });
  const [isCurrentUser, setisCurrentUser] = useState(false);
  const [sessionExpired, setsessionExpired] = useState(false);
  const [homeshow, setHomeShow] = useState(true)
  const [nftshow, setNftShow] = useState(false)

  const [filter, setfilter] = useState({
    limit: 4,
    orderBy: "",
    page: 1,
    collectedAuthor: "",
    collectionId: items?.collection_id,
    order: "",
    author: "",
    createdAuthor: "",
    user_id: user?._id,
    isMore: false,
  });

  const [ActivityFilter, setActivityFilter] = useState({
    limit: 10,
    order: "",
    orderBy: "",
    page: 1,
    createdAuthor: "",
    collectionId: items?.collection_id,
    order: "",
    author: "",
    isMore: false,
  });

  const [LikeFilter, setLikedFilter] = useState({
    isMore: false,
    limit: 10,
    order: "",
    orderBy: "",
    page: 1,
    user_id: profile?.Login?.user?.userId,
  });

  useEffect(() => {
    if (slug) {
      dispatch(getUserByWallet(slug));
    } else {
      dispatch(getCurrentUser(slug));
    }
  }, [slug]);

  useEffect(() => {
    if (profile?.Login?.user?._id === profile?.Profile?.userProfile?._id) {
      setisCurrentUser(true);
    } else {
      setisCurrentUser(false);
    }
  }, [profile?.Login, profile.Profile]);

  useEffect(() => {
    if (profile?.Profile?.userProfile?._id) {
      if (state?.tab === "tab10") {
        setfilter((prevState) => ({
          ...prevState,
          author: null,
          type: "upcoming",
          collectedAuthor: null,
          createdAuthor: profile?.Profile?.userProfile?._id,
          page: 1,
          isMore: false,
        }));
      } else if (state?.tab === "tab1") {
        setfilter((prevState) => ({
          ...prevState,
          createdAuthor: profile?.Profile?.userProfile?._id,
          type: "",
          collectedAuthor: null,
          author: null,
          page: 1,
          isMore: false,
        }));
      } else if (state?.tab === "tab2") {
        setfilter((prevState) => ({
          ...prevState,
          author: null,
          type: "",
          createdAuthor: null,
          collectedAuthor: profile?.Profile?.userProfile?._id,
          page: 1,
          isMore: false,
        }));
      } else if (state?.tab === "tab6") {
        setfilter((prevState) => ({
          ...prevState,
          author: null,
          type: "sold",
          collectedAuthor: null,
          createdAuthor: profile?.Profile?.userProfile?._id,
          page: 1,
          isMore: false,
        }));
      }
    }
  }, [profile?.Profile?.userProfile?._id, state?.tab]);

  useEffect(() => {
    if (profile?.Profile?.userProfile?._id) {
      if (state?.tab === "tab4") {
        setActivityFilter((prevState) => ({
          ...prevState,
          limit: 10,
          order: "",
          orderBy: "",
          page: 1,
          type: "",
          createdAuthor: "",
          order: "",
          author: "",
          user_id: profile?.Profile?.userProfile?._id,
          isMore: false,
        }));
      }
    }
  }, [profile?.Profile?.userProfile?._id, state?.tab]);

  useEffect(() => {
    if (profile?.Profile?.userProfile?._id) {
      if (state?.tab === "tab5") {
        setLikedFilter((prevState) => ({
          ...prevState,
          order: "",
          orderBy: "",
          type: "",
          isMore: false,
          page: 1,
          user_id: profile?.Profile?.userProfile?._id,
        }));
      }
    }
  }, [profile?.Profile?.userProfile?._id, state?.tab]);

  useEffect(() => {
    dispatch(getFavourite(LikeFilter));
  }, [LikeFilter]);

  useEffect(() => {
    dispatch(getActivities(ActivityFilter));
  }, [ActivityFilter]);

  useEffect(() => {
    if (profile?.Login?.user?._id) {
      setfilter((prevState) => ({
        ...prevState,
        user_id: profile?.Login?.user?._id,
      }));
    }
  }, [profile?.Login?.user?._id]);

  useEffect(() => {
    if (!filter?.author && !filter?.collectedAuthor && !filter?.createdAuthor)
      return;
    dispatch(getItems(filter));
  }, [filter]);

  const showMoreItems = (evt) => {
    evt.preventDefault();
    setfilter((prevState) => ({
      ...prevState,
      page: prevState.page + 1,
      isMore: true,
    }));
  };

  const ShowActivityData = (evt) => {
    evt.preventDefault();
    setActivityFilter((prevState) => ({
      ...prevState,
      page: prevState.page + 1,
      isMore: true,
    }));
  };

  useEffect(() => {
    if (showMoreItem?.items) {
      if (filter.isMore) {
        settoggleData((prevState) => [...prevState, ...showMoreItem?.items]);
      } else {
        settoggleData(showMoreItem?.items);
      }
    }
  }, [showMoreItem?.items]);

  useEffect(() => {
    if (activities?.activities) {
      if (ActivityFilter.isMore) {
        setmoreActivity((prevState) => [
          ...prevState,
          ...activities?.activities,
        ]);
      } else {
        setmoreActivity(activities?.activities);
      }
    }
  }, [activities?.activities]);

  useEffect(() => {
    if (user?.role == "USER") {
      setState({ tab: "tab2" });
    } else {
      setState({ tab: "tab1" });
    }
  }, [user]);
  function profilePages(event){

  }
  
  const navigate = useNavigate();
  const pagepath = location.pathname.split('/')
  const activepath = pagepath.filter((res) => res)
  const createPage = pagepath.filter((res) => res === 'createcollection' ||  res === 'createnft')
  const viewCollection = pagepath.filter((res) => res === 'viewcollection')

 
  // useEffect(()=>(
    
  //   $('.subCate').hide(),
  //   $('.cateHead button').on('click', ()=>{
  //     $().toggleClass('active')
  //     $().parent().next().slideToggle()
  //   })
  // ), [])
  
  const [menuactive, setmenuactive] = useState()
  const menuopen = () => {
    setmenuactive(!menuactive)
  }

  
  return (
    <>
   <div className="container-fluid profileBox dashboardprofile">
    
        <Row>
          <Col lg={12}>
          {createPage && (createPage[0] === 'createcollection' || createPage[0] === 'createnft') ? 
          <h1>{createPage[0] === 'createcollection' ? 'Create Collection ': 'List on Marketplace'}</h1> : 
          <h1>{activepath[1] === 'home' ? 'Home': activepath[1] === 'collection' ? 'Collection': activepath[1] === 'nft' ? 'Artwork List ': activepath[1] === 'art'? 'Art':  activepath[1] === 'ownedNft' ? 'Owned Artwork':activepath[1] === 'uploadArt' ? 'Art Submission':''}</h1>
           }
          </Col>
        </Row>
      
   </div>
   <div className="container-fluid p-0">
    <div className="ProfileBoxMaine">
      
        <div className={"leftBox " + (menuactive? 'active':'')} >
        {/* <button className="usersidebtn" onClick={menuopen}>
        <i class="fa-light fa-bars-sort"></i>
        </button> */}
        <div className="profileBoXIn pb-4">
            <div className="profileImgbx adminprofile">
                <img src={user?.profileImage?.link ? user?.profileImage?.link :  "/images/avatar.png"} alt={user.name} />
            </div>
            <h2>{user.name}</h2>
           
            <div className="userProfileData">
              <p className="mb-2"> <i className="fa-light fa-phone"></i> <a rel="noreferrer" href={'tel:'+user.mobileNumber}> {user.mobileNumber}</a></p>
              <p className="mb-2"> <i className="fa-light fa-envelope"></i> <a  rel="noreferrer" href={"mailto:"+user.email}>{user.email}</a></p>
              <p className="text-center mb-2">{user.address} {user.city} {user.state} {user.country}</p>
            </div>
           
            <NavLink to={'view-profile'} className="btn btn-dark rounded-pill py-2 px-4 fw-normal mb-3">View Profile</NavLink>
          </div>
          <div className="nftMenuBox">
            <ul>
              <li><NavLink to="home" activeclassname="active" className={'nav-link'}><div className="menuIcon home"></div> Home</NavLink></li>
                       <li><NavLink to="customArtRequest" activeclassname="active" className={'nav-link'}><div className="menuIcon customArtRequest"></div>Custom Art Request</NavLink></li>
              {user.role !== 'USER' &&<li><NavLink to={'collection/created'} className={'nav-link' + ((activepath[1] === 'collection') ? ' active' : '')} ><div className="menuIcon Collection"></div> Collections</NavLink></li> }
              <li><NavLink to={'ownedNft'} activeclassname="active" className={'nav-link'}><div className="menuIcon ownedNft"></div> Owned Artwork</NavLink></li>
              {user.role !== 'USER' && <li><NavLink to={'art'} activeclassname="active" className={'nav-link'}><div className="menuIcon art"></div> Submit Art</NavLink></li> }
              {user.role !== 'USER' && <li><NavLink to={'artworkproofing'} activeclassname="active" className={'nav-link'}><div className="menuIcon artwork"></div> Artwork Proofing </NavLink></li> }
              {user.role !== 'USER' && <li><NavLink to="nft/created" className={'nav-link' + ((activepath[1] === 'nft') ? ' active' : '')} ><div className="menuIcon Nft"></div> Artworks</NavLink></li> }
              <li><NavLink to="earnings" activeclassname="active" className={'nav-link'  + ((activepath[1] === 'withdrawal-fiet') ? ' active' : '')}><div className="menuIcon earning"></div> Earnings</NavLink></li>
              {/* <li><NavLink to="reviews" activeclassname="active" className={'nav-link'}><div className="menuIcon review"></div> Reviews</NavLink></li> */}
              <li><NavLink to="printrequest" activeclassname="active" className={'nav-link'}><div className="menuIcon printrequest"></div> Print Requests</NavLink></li>
              <li><NavLink to="settings" activeclassname="active" className={'nav-link'}><div className="menuIcon setting"></div>Settings</NavLink></li>
          </ul>
          {/* {} */}
          </div>
        
        </div>
        <div className="rightBox">
        <Outlet  context={[setmenuactive, menuopen]}>
            {/* <Outlet /> */}
        </Outlet>
          {/* {page === 'home'? :''} */}
          {/* <ProfileHome />
          <ProfileNft /> */}
        </div>

      </div>
     
   </div>
    
   </>
    
  );
};

export default Profiletabbing;
